export default "__VITE_ASSET__9e93976b__$_?nuxt_component=async__"